function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAssets = function SvgAssets(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "prefix__Group_172",
    width: 24,
    height: 24,
    "data-name": "Group 172",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_33",
    d: "M0 0h24v24H0z",
    "data-name": "Path 33",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_34",
    d: "M3.6 4.6v11.2h12.8V4.6zM2.8 3h14.4a.8.8 0 0 1 .8.8v12.8a.8.8 0 0 1-.8.8H2.8a.8.8 0 0 1-.8-.8V3.8a.8.8 0 0 1 .8-.8zm9.434 5.434L10.8 7h4v4l-1.434-1.434-3.091 3.091-1.7-1.7-2.261 2.265-1.131-1.131L8.578 8.7l1.7 1.7z",
    "data-name": "Path 34",
    transform: "translate(2 2)",
    style: {
      fill: "#27ae60"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssets, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assets.f9a67ca0.svg";
export { ForwardRef as ReactComponent };